/**
 * Page de démonstration du carrousel CONFILEX MATCH™.
 * Route /demo/match — utile pour QA visuel et démo commerciale.
 *
 * Charge en direct l'endpoint /api/match/lawyers et affiche le carrousel
 * avec la pré-animation. Idéal pour tester sans passer par le wizard
 * d'orientation complet.
 */
import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { apiClient } from "@/lib/api";
import MatchAnalysisLoader from "@/components/MatchAnalysisLoader";
import ExpertCarousel from "@/components/ExpertCarousel";
import { Button } from "@/components/ui/button";

export default function MatchDemo() {
  const [panel, setPanel] = useState(null);
  const [animating, setAnimating] = useState(true);
  const [error, setError] = useState(null);

  const load = async () => {
    setAnimating(true);
    setPanel(null);
    setError(null);
    try {
      const r = await apiClient.post("/match/lawyers", {
        matiere: "droit_social",
        ville: "Lyon",
        keywords: ["licenciement", "prud'hommes"],
        target_size: 3,
      });
      setPanel(r.data);
    } catch (e) {
      setError(e?.response?.data?.detail || "Échec du chargement.");
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="bg-ivory min-h-screen">
      <Navbar variant="light" />
      <div className="max-w-6xl mx-auto px-6 lg:px-10 py-12">
        <div className="flex items-center justify-between flex-wrap gap-3 mb-8">
          <div>
            <p className="text-[10px] uppercase tracking-[0.32em] text-copper mb-1">Démo · QA</p>
            <h1 className="font-serif italic text-3xl text-night">CONFILEX MATCH™ · Carrousel</h1>
            <p className="text-sm text-night/65 mt-1">
              Exemple avec un dossier de type « bulletin de paie », matière droit_social, ville Lyon.
            </p>
          </div>
          <Button onClick={load} variant="outline" className="rounded-sm" data-testid="reload-match">
            Recharger
          </Button>
        </div>

        {error && (
          <div className="p-4 mb-6 rounded-sm border border-bordeaux/30 text-bordeaux text-sm">{error}</div>
        )}

        {animating && !panel && (
          <MatchAnalysisLoader onComplete={() => { /* pas de besoin — re-render automatique au panel */ }} />
        )}

        {panel && (
          <ExpertCarousel
            experts={panel.experts}
            deontologyNotices={panel.deontology_notices || []}
            transparencyNotice={panel.transparency_notice || ""}
            geoExpanded={!!panel.geo_expanded}
            matchId={panel.match_id}
            warning={panel.warning}
          />
        )}
      </div>
      <Footer />
    </div>
  );
}
